<template>
  <div>
 <div class="flex justify-center">
      <img src="@/assets/logo.png" alt="logo" class="logoIlly">
    </div>
    <div class="content-wrapper">
      <p class="title">
        {{ giftText?.topBold || '' }}
      </p>
      <p v-if="giftText?.topNormal" class="subtitle-normal">
        {{ giftText.topNormal }}
      </p>
    </div>

    <div v-if="giftText?.bottomNormal" class="bottom-small-wrapper">
      <p class="bottom-text-normal">
        {{ giftText.bottomNormal }}
      </p>
    </div>

    <div v-if="giftText?.bottomNormalSecond" class="bottom-small-wrapper">
      <p class="bottom-text-small">
        {{ giftText.bottomNormalSecond }}
      </p>
    </div>

    <button @click="goToFirstStep" class="return-home-btn">
          <span>{{ $t('finalPage.returnHome') }}</span>
          <svg
            id="Group_8"
            data-name="Group 8"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="responsive-svg"
            viewBox="0 0 10.016 17.369"
          >
            <defs>
              <clipPath id="clip-path">
                <rect id="Rectangle_20" data-name="Rectangle 20" width="10.016" height="17.369" fill="#fff"/>
              </clipPath>
            </defs>
            <g id="Group_7" data-name="Group 7" clip-path="url(#clip-path)">
              <path
                id="Path_5"
                data-name="Path 5"
                d="M10.016,8.671,1.615.27l0,0h0A.949.949,0,0,0,.269,1.608h0L7.344,8.683.271,15.757h0A.949.949,0,0,0,1.611,17.1h0l8.4-8.4L10,8.683Z"
                transform="translate(0 0)"
                fill="#fff"
              />
            </g>
          </svg>
    </button>
  </div>  
</template>

<script>
export default {
  props: {
    giftText: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToFirstStep() {
      this.$emit('return-home');
    },
  },
};
</script>

<style scoped>
  .logoIlly {
    width: 35%;
    box-shadow: inset 0px 0 20px 20px rgb(43 43 43 / 11%), 0px 3px 20px 0 rgb(43 43 43 / 11%);
  }

.content-wrapper {
  text-align: center;
  color: white;
  padding: 56px 9px 22px 9px;
}

.title {
  font-size: 18px;
  font-weight: 800;
  line-height: 22px;
}

.subtitle-normal {
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
}

.bottom-normal-wrapper {
  text-align: center;
  color: white;
  padding: 0 9px 22px 9px;
}

.bottom-text-normal {
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
}

.bottom-small-wrapper {
  text-align: center;
  color: white;
  padding: 0 9px 22px 9px;
}

.bottom-text-small{
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}

.return-home-btn {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding-top: 50px;
  font-size: 16px;
  font-weight: 700;
  color: white;
}

.responsive-svg {
  width: 10px;
  height: 17px;
}

@media (min-width: 900px) {
   .logoIlly {
      width: 40vw;
   }

  .content-wrapper {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 90px;
    padding-bottom: 40px;
  }

  .title {
    font-size: 35px;
    line-height: 45px;
  }

  .subtitle-normal {
    font-size: 35px;
    line-height: 50px;
  }

  .bottom-normal-wrapper {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 60px;
  }

  .bottom-text-normal {
    font-size: 35px;
    line-height: 45px;
  }

  .bottom-small-wrapper {
    padding-left: 30px;
    padding-right: 30px;
  }

  .bottom-text-small{
    font-size: 30px;
    font-weight: 500;
    line-height: 40px;
  }

  .return-home-btn {
    width: 88vw;
    gap: 30px;
    padding-top: 140px;
    font-size: 34px;
  }

  .responsive-svg {
    width: 18px;
    height: 30px;
  }
}
</style>
